import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import NotificationBanner from '../../components/ui/NotificationBanner';
import PricingCard from '../../components/ui/PricingCard';
import { pricingPlans } from '../../data/pricingPlans';

const Pricing = () => {
    return (
        <>
            <Helmet>
                <title>Pricing - Nexgen Learning - AI-Driven Education</title>
                <meta name="description" content="View NexGen Learning's flexible pricing plans designed to meet your educational needs and budget." />
            </Helmet>
            <Header />
            <NotificationBanner />
            <main>
                {/* Hero Section */}
                <section className="pt-28 pb-20 bg-gradient-to-b from-white to-gray-50">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="text-center">
                            <h1 className="text-5xl py-10 text-primary">|</h1>
                            <h1 className="text-4xl font-bold text-gray-900 mb-6">
                                Flexible Learning <span className="text-primary">Options</span>
                            </h1>
                            <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
                                Choose from flexible session-based learning or traditional monthly subscriptions. Perfect for every learning style and budget.
                            </p>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center">
                                <Link 
                                    to="/membership"
                                    className="bg-primary text-white px-8 py-3 rounded-full font-medium hover:bg-primary-dark transition-colors duration-200"
                                >
                                    View Session Plans
                                </Link>
                                <Link 
                                    to="/contact"
                                    className="border border-primary text-primary px-8 py-3 rounded-full font-medium hover:bg-primary hover:text-white transition-colors duration-200"
                                >
                                    Contact Sales
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Plans Section */}
                <section className="py-20 bg-gray-50">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                            {pricingPlans.map((plan, index) => (
                                <PricingCard key={index} plan={plan} />
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default Pricing; 